import React, { useContext, useEffect, useState } from "react";
import ChartMultiBar from "./components/ChartMultiBar";
import ChartTopLeft from "./components/ChartTopLeft";
import ChartTopRight from "./components/ChartTopRight";
import ChartBottomLeft from "./components/ChartBottomLeft";
import ChartBottomRight from "./components/ChartBottomRight";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/context";
import { localGetMenu } from "../../utils/localStorage";

const DashboardCilents = () => {
  const navigate = useNavigate();
  const { state } = useContext(UserContext);

  const [pageMenu, setPageMenu] = useState({
    list: false,
    details: false,
    create: false,
    update: false,
    assign: false,
    sync: false,
    import: false,
    export: false,
  });
  useEffect(() => {
    let localMenu = JSON.parse(localGetMenu());
    let fakePageMenu = { ...pageMenu };
    let fakeNewMenu = localMenu || [];
    let checkAll = fakeNewMenu.find((x) => x?.fe_route === "/report-clients");
    if (!checkAll) {
      navigate("/");
    } else {
      let checkView = checkAll?.permissions?.find(
        (y) => y?.permission === "VIEW_LIST"
      );
      if (checkView?.status === "INACTIVE") {
        navigate("/");
      } else {
        fakePageMenu = { ...fakePageMenu, list: true };
      }

      fakePageMenu = {
        ...fakePageMenu,
        create:
          checkAll?.permissions?.find((y) => y?.permission === "CREATE")
            ?.status === "ACTIVE"
            ? true
            : false,
        update:
          checkAll?.permissions?.find((y) => y?.permission === "UPDATE")
            ?.status === "ACTIVE"
            ? true
            : false,
        details:
          checkAll?.permissions?.find((y) => y?.permission === "VIEW_DETAIL")
            ?.status === "ACTIVE"
            ? true
            : false,
        assign:
          checkAll?.permissions?.find((y) => y?.permission === "ASSIGN")
            ?.status === "ACTIVE"
            ? true
            : false,
        sync:
          checkAll?.permissions?.find((y) => y?.permission === "SYNC")
            ?.status === "ACTIVE"
            ? true
            : false,
        import:
          checkAll?.permissions?.find((y) => y?.permission === "IMPORT")
            ?.status === "ACTIVE"
            ? true
            : false,
        export:
          checkAll?.permissions?.find((y) => y?.permission === "EXPORT")
            ?.status === "ACTIVE"
            ? true
            : false,
      };

      setPageMenu(fakePageMenu);
    }
  }, [state]);
  return (
    pageMenu.list && (
      <div
        className="userSystem"
        style={{ background: "rgb(252,252,252)", height: "unset" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div className="chartDev">
            <ChartTopLeft />
          </div>
          <div className="chartDev">
            <ChartTopRight />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            margin: "16px 0",
          }}
        >
          <div className="chartDev">
            <ChartBottomLeft />
          </div>
          <div className="chartDev">
            <ChartBottomRight />
          </div>
        </div>
        <div>
          <ChartMultiBar className="chartNew" />
        </div>
      </div>
    )
  );
};

export default DashboardCilents;
